import React from 'react';

/**
 * ConnectionContext — provides account, network, and user role information.
 */
const ConnectionContext = React.createContext({
  account: null,
  networkId: null,
  deployedNetwork: null,
  isConnectedToADeployedToNetwork: false,

  // User roles
  userIsAdmin: false,
  userIsContractOwner: false,
  userIsPayee: false,
  userIsAuthorizedArtist: false,
  userIsProjectArtist: false,
  userHasAProject: null,
  contractOwner: null,
  artistScreeningEnabled: false,

  // Admin data
  immutablesWEB: "",
  immutablesURI: "",
  useMetadataServer: true,
  teammembers: null,
  authorizedArtists: null,
});

ConnectionContext.displayName = 'ConnectionContext';

export default ConnectionContext;
